export default {
    organizationManager: {
        organization: {
            getOrgTree:  '/api/organizationManager/getOrgTree',//无权限
            getTreeTable: '/api/organizationManager/getTreeTable',
            getTreeImg: '/api/organizationManager/getTreeImg',
            getOrganizationDetail: '/api/organizationManager/getOrganizationDetail',
            saveOrg: '/api/organizationManager/saveOrg',
            updateOrg: '/api/organizationManager/updateOrg',
            delOrg: '/api/organizationManager/delOrg',
            getCompanyList: '/api/organizationManager/getCompanyList'
        },
        job: {
            getJobList: '/api/jobManager/getJobList',
            getJobDetail: '/api/jobManager/getJobDetail',
            saveJob: '/api/jobManager/saveJob',
            updateJob: '/api/jobManager/updateJob',
            delJob: '/api/jobManager/delJob'
        },
        post: {
            getPostList: '/api/postManager/getPostList',
            getPostDetail: '/api/postManager/getPostDetail',
            savePost: '/api/postManager/savePost',
            updatePost: '/api/postManager/updatePost',
            getPostOrgTree: '/api/postManager/getPostOrgTree',
            getPostJobList: '/api/postManager/getPostJobList',
            delPost: '/api/postManager/delPost'
        },
        employee: {
            getEmployeeList: '/api/employeeManager/getEmployeeList',
            getEmployeeDetail: '/api/employeeManager/getEmployeeDetail',
            saveEmployee: '/api/employeeManager/saveEmployee',
            updateEmployee: '/api/employeeManager/updateEmployee',
            getEmployeePostList: '/api/employeeManager/getEmployeePostList',
            delEmployee: '/api/employeeManager/delEmployee',
            getPersonStatusOptions: '/api/employeeManager/getPersonStatusOptions',
            getPersonQualificationsOptions: '/api/employeeManager/getPersonQualificationsOptions',
            getEmployeeOptions: '/api/employeeManager/getEmployeeOptions',
            getEmployees:"/api/employeeManager/getEmployees"
        }
    }
}